import { requiredValidation, validateEmail, equalsValidation, uniqueValidation, ValidationRule } from './rules';
import { ValidationType, SimpleFormValidationProp, SimpleFormValidationRule } from './types';

const convertion = {
  [ValidationType.Required]: (field: string) => requiredValidation(field),
  [ValidationType.Email]: (field: string) => validateEmail(field),
  [ValidationType.Equals]: (field: string, otherFields: string | string[]) =>
    equalsValidation(field, otherFields),
  [ValidationType.Unique]: (field: string, otherFields: string | string[], rules?: ValidationRule[]) =>
    uniqueValidation(field, otherFields, rules)
};

const nullConvertion = (field: string, otherFields: string | string[], rules?: ValidationRule[]) => undefined;

export const convertToValidationRule = (field: string, validationProp: SimpleFormValidationProp): SimpleFormValidationRule => {
  const converter = convertion[validationProp.type] || nullConvertion;
  return converter(field, validationProp.fields, validationProp.rules);
};
